import { SORT_ORDER } from 'lumen/utils/constants/general-constants';

export default function hotelinfoSortHelper(
  rowA,
  rowB,
  sortDirection,
  ownHotelAndAllCompetitors,
) {
  /**
   * Sort function for ember-table
   * @param {Object} rowA - First row to compare
   * @param {Object} rowB - Second row to compare
   * @param {String} sortDirection - 'asc' or 'desc'
   * @param {Array} ownHotelAndAllCompetitors - Array of hotelinfos
   * @returns {Number} -1, 0, or 1
   *
   * Both rows must contain a hotelinfo object with an id property
   */

  const aIndex = ownHotelAndAllCompetitors.findIndex(
    (item) => item.id === rowA.hotelinfo.id,
  );
  const bIndex = ownHotelAndAllCompetitors.findIndex(
    (item) => item.id === rowB.hotelinfo.id,
  );
  return sortDirection === SORT_ORDER.ASCENDING
    ? aIndex - bIndex
    : bIndex - aIndex;
}
